/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Quota_UnlimitedInputs */

const fr_membership_quota_unlimited = /** @type {(inputs: Membership_Quota_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illimité`)
};

/**

* @param {Membership_Quota_UnlimitedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_quota_unlimited = /** @type {((inputs?: Membership_Quota_UnlimitedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Quota_UnlimitedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_quota_unlimited(inputs)
});